import { useQuery } from "@tanstack/react-query";

import { getChapterByModuleApiCall } from "./utils.api";
import { chapterByModuleKeys } from "../../../../redux/services/getChapterByModule";

export const useGetChapterByModuleTypeKeys = (payload) =>{
    const {languageId , courseId, moduleId}= payload;

    return useQuery({
        queryKey: chapterByModuleKeys.getChapterByModuleKeys(),
        queryFn: () => getChapterByModuleApiCall({languageId , courseId, moduleId }),
    });
}